export default "__VITE_ASSET__CAyBRiFp__"